<template>
  <a-modal
    title="企业排班表"
    :close-on-click-modal="false"
    :visible.sync="visible"
    v-if="visible"
    class="myModal1"
    @cancel="onCancelBtnClick"
    @ok="onOKBtnClick"
    width="60%"
    centered
    :z-index="100"
  >
    <a-form-model
      :model="dataForm"
      ref="dataForm"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :rules="dataRule"
    >
      <a-form-model-item label="企业名称" prop="companyName">
        <a-input
          v-model="dataForm.companyName"
          placeholder="企业名称"
          disabled
        ></a-input>
      </a-form-model-item>
      <!-- <a-form-model-item label="企业类型" prop="companyType">
        <a-input
          v-model="dataForm.companyType"
          placeholder="企业类型"
          disabled
        ></a-input>
      </a-form-model-item> -->
      <a-form-model-item label="企业生产情况" prop="produceFlag">
        <a-select v-model="dataForm.produceFlag" placeholder="企业生产情况">
          <a-select-option label="在生产" :value="0">在生产</a-select-option>
          <a-select-option label="未生产" :value="1">未生产</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remakes">
        <a-textarea
          type="text"
          :auto-size="{ minRows: 5, maxRows: 5 }"
          placeholder="备注"
          v-model="dataForm.remakes"
        />
      </a-form-model-item>
      <div>
          <div style="display:flex;">
            <div style="margin-right:10px;">
      <vxe-button  style="margin-right:10px;" status="primary" @click="importTemplate()"><a-icon type="download" />下载导入模板</vxe-button>
      <a-upload
              :customRequest="uploadChange"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
              :show-upload-list="false"
      >
        <vxe-button  :loading="submitLoading" status="primary" > <a-icon type="cloud-upload" /> 导入</vxe-button>
      </a-upload>
            </div>
          </div>
      </div>
      <div class="tab-title">{{month}}月</div>
      <div class="tab-tip">*企业上报排班后，可以进行修改；单值班当天及之前的值班人和联系电话不给予修改</div>
      <div class="table-box">
        <table align="center" class="table" border="1">
          <tbody>
            <tr style="background: #e9fbfe;" v-if="dataForm && dataForm.scheduleDutyDtoList && dataForm.scheduleDutyDtoList.length > 0">
                <th class="zxstyle">值班人员/日期</th>
                <th class="zxstyle" v-for="(item, index) in dataForm.scheduleDutyDtoList" :key="index">{{item.dutyTime}}</th>
            </tr>
            <tr v-if="dataForm && dataForm.scheduleDutyDtoList && dataForm.scheduleDutyDtoList.length > 0">
              <td class="zxstyle" align="center"><div style="width: 180px;">第一值班人</div></td>
              <td class="zxstyle" v-for="(data, i) in dataForm.scheduleDutyDtoList" :key="i">
                <div style="width: 200px;">
                  <a-input v-model="data.dutyOneName" :disabled="beforeCurrentTime(data.dutyTime)" placeholder="第一值班人" ></a-input>
                </div>
              </td>
            </tr>
            <tr v-if="dataForm && dataForm.scheduleDutyDtoList && dataForm.scheduleDutyDtoList.length > 0">
              <td class="zxstyle" align="center"><div style="width: 180px;">联系电话</div></td>
              <td class="zxstyle" v-for="(data, i) in dataForm.scheduleDutyDtoList" :key="i">
                <div style="width: 200px;">
                  <a-input v-model="data.dutyOnePhone" :disabled="beforeCurrentTime(data.dutyTime)" placeholder="联系电话" ></a-input>
                </div>
              </td>
            </tr>
            <tr v-if="dataForm && dataForm.scheduleDutyDtoList && dataForm.scheduleDutyDtoList.length > 0">
              <td class="zxstyle" align="center"><div style="width: 180px;">第二值班人</div></td>
              <td class="zxstyle" v-for="(data, i) in dataForm.scheduleDutyDtoList" :key="i">
                <div style="width: 200px;">
                  <a-input v-model="data.dutyTwoName" :disabled="beforeCurrentTime(data.dutyTime)" placeholder="第二值班人" ></a-input>
                </div>
              </td>
            </tr>
            <tr v-if="dataForm && dataForm.scheduleDutyDtoList && dataForm.scheduleDutyDtoList.length > 0">
              <td class="zxstyle" align="center"><div style="width: 180px;">联系电话</div></td>
              <td class="zxstyle" v-for="(data, i) in dataForm.scheduleDutyDtoList" :key="i">
                <div style="width: 200px;">
                  <a-input v-model="data.dutyTwoPhone" :disabled="beforeCurrentTime(data.dutyTime)" placeholder="联系电话" ></a-input>
                </div>
              </td>
            </tr>
            <tr v-if="dataForm && dataForm.scheduleDutyDtoList && dataForm.scheduleDutyDtoList.length > 0">
              <td class="zxstyle"><div style="width: 180px;">第三值班人</div></td>
              <td class="zxstyle" v-for="(data, i) in dataForm.scheduleDutyDtoList" :key="i">
                <div style="width: 200px;">
                  <a-input v-model="data.dutyThreeName" :disabled="beforeCurrentTime(data.dutyTime)" placeholder="第三值班人" ></a-input>
                </div>
              </td>
            </tr>
            <tr v-if="dataForm && dataForm.scheduleDutyDtoList && dataForm.scheduleDutyDtoList.length > 0">
              <td class="zxstyle"><div style="width: 180px;">联系电话</div></td>
              <td class="zxstyle" v-for="(data, i) in dataForm.scheduleDutyDtoList" :key="i">
                <div style="width: 200px;">
                  <a-input v-model="data.dutyThreePhone" :disabled="beforeCurrentTime(data.dutyTime)" placeholder="联系电话" ></a-input>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </a-form-model>
    <span slot="footer" class="dialog-footer">
      <a-button  @click="visible = false">取消</a-button>
      <a-button type="primary" @click="onOKBtnClick()" :loading="submitLoading">确定</a-button>
    </span>
  </a-modal>
</template>
<script>
import { dutyInfo, saveOrUpdateDuty ,saveImportList} from "@/api/schedule";
import { importExcel2Json } from '@/utils/excel/importExcel.js'
import { exportJsonToExcel} from '@/utils/excel/Export2Excel.js'
export default {
  data() {
    return {
      startTime:'',
      endTime:'',
      dataRule: {
        produceFlag: [
          { required: true, message: "企业生产情况不能为空", trigger: "blur" }
        ],
      },
      labelCol: { span: 3 },
      wrapperCol: { span: 19 },
      visible: false,
      dataForm: {
        scheduleId: null,
      },
      day: new Date().getDate(),
      month: new Date().getMonth() + 1,
      dataList: [],
      pageSize: 10,
      total: 0,
      dataListLoading: false,
      dataListSelections: [],
      submitLoading: false
    };
  },
  methods: {
    beforeCurrentTime(dutyTime) {
      if(dutyTime) {
        let date = new Date()
        const year = date.getFullYear()
        let month = date.getMonth() + 1
        let strDate = date.getDate()
        if(month < 10) month = `0${month}`
        if(strDate < 10) strDate = `0${strDate}`
        const nowDate = `${year}-${month}-${strDate}`
        if(parseInt(dutyTime.replaceAll('-','')) <= parseInt(nowDate.replaceAll('-',''))) {
          return true
        }else {
          return false
        }
      }else {
        return true
      }
    },
    init(item,scheduleId) {
      this.visible = true;
      this.startTime = item.startTime||''
      this.endTime = item.endTime||''
      this.dataForm.scheduleId = scheduleId
      this.$nextTick(() => {
        if (scheduleId) {
          dutyInfo(scheduleId).then((data) => {
            this.dataForm = data
            this.dataForm.startTime = item.startTime
            this.dataForm.endTime = item.endTime
          });
          this.month = new Date(item.startTime).getMonth() + 1
        }
      });
    },
    handlePageChange({ currentPage, pageSize }) {
      this.dataForm.currentPage = currentPage;
      this.dataForm.pageSize = pageSize;
      this.getDataList();
    },
    onOKBtnClick() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          saveOrUpdateDuty(this.dataForm).then(() => {
            this.$message.success({
              content: "操作成功",
              duration: 2,
            });
            this.visible = false;
            this.submitLoading = false
            this.resest();
            this.$emit("submitForm");
          }).catch(()=>{
            this.submitLoading = false
          });
        }
      });
    },
    onCancelBtnClick() {
      this.visible = false;
    },
    resest() {
      this.dataForm = {
        scheduleId: null,
      }
    },
    getDayAll(starDay, endDay) {

        　　 var arr = [];
            var dates = [];

            // 设置两个日期UTC时间
        　　　var db = new Date(starDay);
        　　　var de = new Date(endDay);

            // 获取两个日期GTM时间
        　　　var s = db.getTime() - 24 * 60 * 60 * 1000;
        　　　var d = de.getTime() - 24 * 60 * 60 * 1000;

            // 获取到两个日期之间的每一天的毫秒数
        　　　for (var i = s; i <= d;) {
        　　　　　　i = i + 24 * 60 * 60 * 1000;
                arr.push(parseInt(i))
        　　　}

            // 获取每一天的时间  YY-MM-DD
            for( var j in arr ){
                var time = new Date(arr[j]);
                var year = time.getFullYear(time);
                var mouth = (time.getMonth() + 1)>=10?(time.getMonth() + 1):('0'+(time.getMonth() + 1));
                var day = time.getDate()>=10?time.getDate():('0'+time.getDate());
                var YYMMDD = year + '-' + mouth + '-' + day;
                dates.push(YYMMDD)
            }

            return dates
        },
    // 下载模板
    importTemplate () {
      var dataList = [];
      let dateList =this.getDayAll(this.startTime,this.endTime)
      if(dateList.length>0){
        dateList.forEach((x,i)=>{
          dataList[i] ={}
          dataList[i].date=x
        })
      }
      console.log(dataList);
      var tHeader = ['值班日期（YYYY-MM-DD）', '第一值班人', '该值班人联系电话', '第二值班人', '该值班人联系电话', '第三值班人', '该值班人联系电话']
      var filterVal = ['date']
      exportJsonToExcel(tHeader, filterVal, dataList, '企业排班导入模板')
    },
    /**
     * 导入excel数据
     */
    uploadChange (file) {
      let that = this
      this.uploading = true
      let headerKeys =  ['dutyTime','dutyOneName','dutyOnePhone','dutyTwoName','dutyTwoPhone','dutyThreeName','dutyThreePhone']
      // 读取excel内容转化为对象列表

      importExcel2Json(file, headerKeys).then((res) => {
        // 读取全部列表数据
        let sheetList = res[0].sheet
        let dataCount = sheetList.length - 1
        this.$confirm('是否导入排班数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          // console.log('确认：', res)
          // 校验数据完整性，重新组装数据
          let contentList = sheetList.slice(1, sheetList.length)
          // 标识数据是否正确
          let errFlag = false
          // 错误提示信息
          let errMsg = ''
          let resultList = []
          let idx = 1
          const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/
          contentList.forEach(item => {
            idx = idx + 1
            if (!item.dutyTime || !regex.test(item.dutyTime)) {
              errMsg = errMsg + '第【' + idx + '】行日期格式错误！正确格式示例：2023-07-01\n'
              errFlag = true
            }
            resultList.push({
              dutyTime: item.dutyTime,
              dutyOneName: item.dutyOneName,
              dutyOnePhone: item.dutyOnePhone,
              dutyTwoName: item.dutyTwoName,
              dutyTwoPhone: item.dutyTwoPhone,
              dutyThreeName: item.dutyThreeName,
              dutyThreePhone: item.dutyThreePhone
            })
          })
          // 组装请求参数
          if (!errFlag) {
            let params = {
              scheduleId: that.dataForm.scheduleId,
              list: resultList
            }
            that.saveImportList(params)
          } else {
            that.$confirm(errMsg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {})
                    .catch(() => {});
          }
        }).catch(() => {});
      })
    },
    saveImportList (params) {
      let that = this
      that.submitLoading = true
      try{
        saveImportList(params).then((data) => {
          that.submitLoading = false
          this.visible = true
          dutyInfo(this.dataForm.scheduleId).then((data) => {
            this.$message.success({
              content: "上报成功",
              duration: 2,
            });
            this.dataForm.scheduleDutyDtoList = data.scheduleDutyDtoList
          });
        })
      } catch (e) {
        that.submitLoading = false
        // console.log(e)
        this.$confirm('数据缺失或错误，请检查Excel后重新导入！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        }).catch(() => {});
      }
    },
  },
};
</script>
<style scoped>
  .tab-title{
    font-size: 28px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tab-tip{
    font-size: 12px;
    color: red;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .table-box{
    padding: 20px;
    overflow-x: auto;
  }
  table{
    table-layout: fixed;
    border-color: #b8d7ed;
  }
  .zxstyle{
    width: 5000px;
    padding: 10px;
    text-align: center;
      /* font-weight: bold; */
  }
  .ly {
      text-align: center;
      /* font-size: 25px; */
      font-weight: normal;
      color: #000;
  }
  .table>tbody>tr>td {
    vertical-align: middle;
  }
  .dialog-footer{
    display: flex;
    justify-content: center;
  }
</style>

